import React from 'react';
import urlBase from '../url-base';
import axios from 'axios';

class ConfirmProposal extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      success: null,
      cancelada: null,
      wasConfirmed: false
    };

    this.styles = {};
  }

  componentWillMount() {
    let salesId = window.location.href.split('cp=')[1];
    let dataSend = {
      id: salesId
    };

    if (dataSend.id === undefined || dataSend.id.length === 0) {
      alert('Link de confirmação incorreto');
    } else {
        axios.get(urlBase.loopBack + 'Sales?filter={"where": {"id": "' + salesId + '"}, "include": ["financialManager"]}')      
        .then((resultado) => {
        if (resultado.data[0] !== undefined) {
          const saleData = resultado.data[0]; // Dados da venda vindos do backend
          console.log(resultado.data[0])
          if (saleData.status === "CANCELADO") {
            let state = this.state;
            state.loading = false;
            state.success = null;
            state.wasConfirmed = false;
            state.cancelada = true;  
            this.setState(state);
          } else {
            axios.post(urlBase.loopBack + 'Sales/ConfirmProposal', dataSend)
            .then((result) => {
              if (result.data.wasConfirmed === true) {
                let state = this.state;
                state.loading = false;
                state.success = null;
                state.wasConfirmed = true;
                this.setState(state);
              } else {
                let dataConfirm = {
                  id: dataSend.id,
                  type: 'FINANCIALMANAGER'
                };

                axios.post(urlBase.loopBack + 'Sales/SendEmailInValidation', dataConfirm)
                .then(() => {

                  let state = this.state;
                  state.loading = false;
                  state.success = true;
                  state.wasConfirmed = false;
                  this.setState(state);
                  const rawResponsibility = (saleData && saleData.financialManager && saleData.financialManager.responsibility) || '0';
                  const numericValue = parseFloat(String(rawResponsibility).replace(',', '.')) || 0;
// --- DISPARO VIA GOOGLE TAG MANAGER (dataLayer) ---
                  if (saleData && saleData.tipoVenda === 'LINK DIRETO') {
                    window.dataLayer = window.dataLayer || [];

                    // 1. Limpa o objeto ecommerce antigo para evitar fusão de dados
                    window.dataLayer.push({ ecommerce: null });

                    // 2. Garante que o valor seja do tipo Number
                    const parsedValue = typeof numericValue === 'number' 
                      ? numericValue 
                      : parseFloat(String(numericValue).replace(',', '.').replace(/[^0-9.]/g, ''));

                    // 3. Dispara o evento de purchase
                    window.dataLayer.push({
                      event: 'purchase',
                      ecommerce: {
                        transaction_id: String(saleData.id),
                        value: parsedValue || 0,
                        currency: 'BRL',
                        items: [
                          {
                            item_id: String(saleData.id),
                            item_name: 'Plano Odontológico',
                            price: parsedValue || 0,
                            quantity: 1
                          }
                        ]
                      }
                    });
                  }
// ------------------------------------------

                })
                .catch(function (error) {
                  alert(error);
                });              
              }
            })
            .catch(() => {
              let state = this.state;
              state.loading = false;
              state.success = false;
              state.wasConfirmed = false;
              this.setState(state);
            });          

          }

        }
      })
      .catch(function (erro) {
        //eslint-disable-next-line no-console
        console.log(erro);
      });

    }
  }

  render() {
    return (
      <div>
        {
          this.state.loading === true ? (
            <div style={{textAlign: 'center', marginTop: 70, color: '#505050'}}>
              <p>
                Realizando a confirmação...
                <i
                  style={{width: 16, marginLeft: 5 }}
                  className="fa fa-spinner fa-spin">
                  &nbsp;
                </i>
              </p>
            </div>
          ) : (
            this.state.cancelada !== true ? (
              this.state.success !== null ? (
                this.state.success === true ? (
                  <div style={{textAlign: 'center', marginTop: 70, color: '#505050'}}>
                    <h1 style={{fontFamily: 'RubikBold', fontSize: 30}}>Adesão confirmada com sucesso.</h1>
                  </div>
                ) : (
                  <div style={{textAlign: 'center', marginTop: 70, color: '#505050'}}>
                    <p>Foi encontrado um problema ao confirmar a proposta.</p>
                    <p>Por favor, tente novamente.</p>
                  </div>
                )
              ) : (
                this.state.wasConfirmed === true ? (
                  <div style={{textAlign: 'center', marginTop: 70, color: '#505050'}}>
                    <h1 style={{fontFamily: 'RubikBold', fontSize: 30}}>Adesão já confirmada anteriormente.</h1>
                  </div>
                ) : ('')
              )
            ) : (
              <div style={{textAlign: 'center', marginTop: 70, color: '#505050'}}>
                <h1 style={{fontFamily: 'RubikBold', fontSize: 30}}>Essa proposta encontra-se cancelada, portanto, não pode ser confirmada.</h1>
              </div>                    
            )
          )
        }
      </div>
    );
  }
}

export default ConfirmProposal;


/** WEBPACK FOOTER **
 ** ./src/components/ConfirmProposal.js
 **/